/**
 * What the unsubscribe page does when the server's subscription record arrives after the page
 * opened without it (df-e26cc1c4b021). A warm restart shows the restored page before its server
 * login, so the page filter lets the unsubscribe page open while it cannot yet tell whether the
 * person has anything to cancel, and the page decides once the record is in.
 *
 * Leaving is a request to the nav controller's post-login route owner, which waits for a login
 * retry or warm resume Phase B that is already moving the person (df-53c89a39b0e6), so this
 * decision no longer has to know about either.
 */
export enum UnsubscribeRecordDecision {
  /** the person can cancel: stay, and the Unsubscribe button becomes usable */
  Stay = 'Stay',
  /** nothing to cancel: the person is sent to their default page */
  Leave = 'Leave',
}

export interface UnsubscribeRecordState {
  /** the arrived record shows a subscription this person can cancel */
  canCancelSubscription: boolean;
}

export function decideOnSubscriptionRecord(state: UnsubscribeRecordState): UnsubscribeRecordDecision {
  return state.canCancelSubscription ? UnsubscribeRecordDecision.Stay : UnsubscribeRecordDecision.Leave;
}
